import { createAuthClient } from 'better-auth/client';
import { setToken, clearToken } from './sw.js';

// No client-side plugin needed for bearer — the server's bearer() plugin sets
// the `set-auth-token` response header and accepts `Authorization: Bearer <token>`.
// We capture the header manually after sign-in and push the token to the SW.
export const authClient = createAuthClient({
  baseURL: window.location.origin,
  fetchOptions: {
    onSuccess: async (ctx) => {
      const token = ctx.response.headers.get('set-auth-token');
      if (token) await setToken(token);
    },
  },
});

/**
 * After any sign-in, move the session token out of client-visible storage
 * and into the Service Worker. Returns `true` if a token was captured.
 */
export async function captureTokenFromResponse(headers: Headers): Promise<boolean> {
  const token = headers.get('set-auth-token');
  if (!token) return false;
  await setToken(token);
  return true;
}

export async function signOut(): Promise<void> {
  try {
    await authClient.signOut();
  } finally {
    await clearToken();
  }
}

export type { AuthClient } from 'better-auth/client';
